var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhanHeMed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#F06866"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13979_182036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2372 8.19453C25.9211 6.84499 22.9485 7.62918 21.5989 9.94529L16.1278 19.3556L10.6567 28.7477C9.30715 31.0638 10.0913 34.0365 12.4075 35.386C14.7236 36.7356 17.6962 35.9514 19.0458 33.6353L24.5169 24.2432L29.988 14.8328C31.3375 12.5167 30.5534 9.54407 28.2372 8.19453ZM29.4774 14.541L24.0245 23.9149L16.6567 19.6292L22.1096 10.2553C22.6932 9.25228 23.605 8.55927 24.7175 8.26748C25.8117 7.97568 26.9606 8.13982 27.9454 8.70517C29.9698 9.89058 30.6628 12.4985 29.4774 14.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9821 30.6991C33.5627 33.6353 30.6448 34.3465 28.6752 34.3283C25.739 34.31 23.3682 32.7052 23.3682 30.6991C23.3682 30.6626 23.3682 32.5775 23.3682 32.8146C23.3682 34.8207 25.739 36.4438 28.6752 36.4438C31.6113 36.4438 33.9821 34.8207 33.9821 32.8146C33.9821 32.5775 34.0004 30.6261 33.9821 30.6991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7269 30.0426C33.5627 28.1459 31.2466 26.6322 28.4199 26.6322C28.1828 26.6322 27.964 26.6505 27.7451 26.6687L28.7846 28.766L31.0825 33.4164V33.4346C32.6691 32.8146 33.7451 31.6292 33.7451 30.2796C33.7269 30.2067 33.7269 30.1155 33.7269 30.0426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9148 33.7447L27.3981 28.6565L26.541 26.924C24.8632 27.5076 23.6778 28.6748 23.623 30.0426C23.623 30.079 23.623 30.1155 23.623 30.1702C23.623 32.1763 25.9939 33.7994 28.93 33.7994C29.2583 33.8176 29.5866 33.7994 29.9148 33.7447Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13979_182036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 28.924,
    fill: "white",
    transform: "translate(10 7.53799)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhanHeMed);
export default __webpack_public_path__ + "static/media/PhanHeMed.808db06b.svg";
export { ForwardRef as ReactComponent };